import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

const lockClass = 'window-lock'

@Component({ abstract: true })
class ScrollLocker extends Vue {
  @Prop({ type: Boolean, default: false }) locked

  lastScrollTop = null

  @Watch('locked')
  onScrollLocked (isLocked) {
    isLocked ? this.lockPage() : this.unlockPage()
  }

  lockPage () {
    const root = document.documentElement
    const scrollBarGap = window.innerWidth - document.documentElement.clientWidth
    this.lastScrollTop = window.scrollY || window.pageYOffset

    this.$el.style.top = `-${this.lastScrollTop}px`
    this.$el.style.right = `${scrollBarGap}px`
    root.style.setProperty('--scroll-bar-gap-x', scrollBarGap + 'px')
    document.body.classList.add(lockClass)
  }

  unlockPage () {
    document.body.classList.remove(lockClass)
    this.$el.style.top = null
    this.$el.style.right = null

    window.scrollTo(0, this.lastScrollTop)
    this.lastScrollTop = null
  }

  render (createElement) {
    return this.$slots.default
  }
}

export default ScrollLocker
